import { cn } from '@/shared/lib/utils/classnames';
import type { TagListBlock as TagListBlockType } from '@/shared/types/blocks';

type TagListBlockProps = Omit<TagListBlockType, 'type' | 'id'>;

/**
 * TagListBlock - 태그 목록
 *
 * 태그들을 가로로 나열합니다.
 */
export function TagListBlock({ tags, variant = 'outline' }: TagListBlockProps) {
  const tagClass = {
    outline: 'border border-border bg-transparent text-foreground',
    filled: 'bg-primary/10 text-primary border-0',
  }[variant];

  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((tag) => (
        <span key={tag} className={cn('px-2 py-0.5 text-xs font-medium rounded', tagClass)}>
          {tag}
        </span>
      ))}
    </div>
  );
}
